import ourLocalStorage from '../storage/localStorage';

class TempSubscriberPassHandler {
  // Class to set a temporary token to allow the user to bypass the newspost gate
  // because the user's updated lytics segments may not be immediately reflected
  constructor() {
    this.tokenName = `${window.siteName.toLowerCase().replace(/ /g, '_')}_sub`;
  }

  setEditorialGateBypassToken() {
    const tokenData = {
      timestamp: Date.now(),
    };
    ourLocalStorage.setItem(this.tokenName, JSON.stringify(tokenData));
  }

  getTimestampFromLocalStorage() {
    const token = ourLocalStorage.getItem(this.tokenName);
    return token ? token.timestamp : '';
  }

  hasValidToken() {
    const startDate = this.getTimestampFromLocalStorage();

    if (typeof startDate !== 'number') {
      return false;
    }

    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const today = Date.now();
    const expiryDays = 1;

    const totalDays = expiryDays * millisecondsPerDay;
    const dateDifference = today - totalDays;

    return dateDifference <= startDate;
  }
}

export default TempSubscriberPassHandler;
